import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center">
      <div>
        <img src={LOGO_URL} alt="" className="mx-auto h-24 w-24 object-contain opacity-60" />
        <div className="overline mt-6">404</div>
        <h1 className="mt-2 font-display text-5xl text-chrome uppercase">Off Beat</h1>
        <p className="mt-3 text-white/60">This page isn't on the routine. Let's get you back.</p>
        <Link to="/" className="btn-electric mt-8 inline-flex" data-testid="notfound-home-btn">Back Home</Link>
      </div>
    </div>
  );
}
